import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M15.53.387a.75.75 0 0 1 0 1.06L1.366 15.614a.75.75 0 1 1-1.061-1.061L14.47.387a.75.75 0 0 1 1.06 0"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M.305.387a.75.75 0 0 1 1.06 0L15.53 14.552a.75.75 0 0 1-1.06 1.06L.305 1.449a.75.75 0 0 1 0-1.06"/>' }
  })
);